export default "__VITE_ASSET__9ohuLpLs__"